import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { shareInfo } from '@dc-platform/dc-interaction'
import { constantRoutes } from '@/router'
import type { RouteRecordRaw } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()

const include = ref<string[]>([])
const isShow = ref<boolean>(true)

// 获取不需要缓存的路由  start
const exclude = ref<string[]>([])
const getRouteNoCache = (routerList: RouteRecordRaw[]) => {
  const cacheList: string[] = []
  function getCacheList(list: RouteRecordRaw[]) {
    list.forEach((item) => {
      if (item.meta?.noCache) cacheList.push(item.name as string)
      if (item.children) getCacheList(item.children)
    })
  }
  getCacheList(routerList)
  return cacheList
}
exclude.value = getRouteNoCache(constantRoutes)
// 获取不需要缓存的路由  end

shareInfo.onKeepAliveData((data) => {
  include.value = data.include
  isShow.value = data.isShow
})

return (_ctx: any,_cache: any) => {
  const _component_dc_keep_alive = _resolveComponent("dc-keep-alive")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx((slotProps) => [
      _createVNode(_component_dc_keep_alive, {
        include: include.value,
        exclude: exclude.value
      }, {
        default: _withCtx(() => [
          (isShow.value)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(slotProps.Component), {
                key: _unref(route).fullPath
              }))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["include", "exclude"])
    ]),
    _: 1
  }))
}
}

})